//@flow
import React, { type Node } from "react";

type PasswordProps = {
  type: string
};

const Password = (props: PasswordProps): Node => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M19.7062 10.2235L20.0836 9.89548L20.0813 9.89295L19.7062 10.2235ZM2.29385 10.2235L1.91869 9.89294L1.91647 9.89549L2.29385 10.2235ZM2.20001 10.4745H2.70001H2.20001ZM2.29385 10.7255L1.91647 11.0535L1.91869 11.0561L2.29385 10.7255ZM19.7062 10.7255L20.0813 11.0561L20.0835 11.0535L19.7062 10.7255ZM13.1786 10.4745C13.1786 11.6777 12.2032 12.6531 11 12.6531V13.6531C12.7555 13.6531 14.1786 12.23 14.1786 10.4745H13.1786ZM11 12.6531C9.7968 12.6531 8.82141 11.6777 8.82141 10.4745H7.82141C7.82141 12.23 9.24451 13.6531 11 13.6531V12.6531ZM8.82141 10.4745C8.82141 9.27131 9.7968 8.29593 11 8.29593V7.29593C9.24451 7.29593 7.82141 8.71903 7.82141 10.4745H8.82141ZM11 8.29593C12.2032 8.29593 13.1786 9.27131 13.1786 10.4745H14.1786C14.1786 8.71903 12.7555 7.29593 11 7.29593V8.29593ZM20.0813 9.89295C19.6215 9.37105 18.4785 8.15745 16.8989 7.07096C15.3242 5.98784 13.2706 5 11 5V6C12.9861 6 14.8405 6.8688 16.3322 7.89487C17.819 8.91758 18.9008 10.0657 19.331 10.554L20.0813 9.89295ZM11 5C8.72941 5 6.67578 5.98784 5.1011 7.07096C3.52154 8.15745 2.37852 9.37105 1.91869 9.89295L2.66901 10.554C3.09924 10.0657 4.18098 8.91758 5.66782 7.89487C7.15955 6.8688 9.01397 6 11 6V5ZM1.91647 9.89549C1.77688 10.0561 1.70001 10.2617 1.70001 10.4745H2.70001C2.70001 10.5028 2.68979 10.5301 2.67123 10.5515L1.91647 9.89549ZM1.70001 10.4745C1.70001 10.6873 1.77688 10.8929 1.91647 11.0535L2.67123 10.3975C2.68979 10.4189 2.70001 10.4462 2.70001 10.4745H1.70001ZM1.91869 11.0561C2.37852 11.578 3.52154 12.7916 5.1011 13.8781C6.67578 14.9612 8.72941 15.949 11 15.949V14.949C9.01397 14.949 7.15955 14.0802 5.66782 13.0541C4.18098 12.0314 3.09924 10.8833 2.66901 10.395L1.91869 11.0561ZM11 15.949C13.2706 15.949 15.3242 14.9612 16.8989 13.8781C18.4785 12.7916 19.6215 11.578 20.0813 11.0561L19.331 10.395C18.9008 10.8833 17.819 12.0314 16.3322 13.0541C14.8405 14.0802 12.9861 14.949 11 14.949V15.949ZM20.0835 11.0535C20.2231 10.8929 20.3 10.6873 20.3 10.4745H19.3C19.3 10.4462 19.3102 10.4189 19.3288 10.3975L20.0835 11.0535ZM20.3 10.4745C20.3 10.2617 20.2231 10.0561 20.0835 9.89549L19.3288 10.5515C19.3102 10.5301 19.3 10.5028 19.3 10.4745H20.3Z"
        fill="#345948"
      />
      {props.type === "close" ? (
        <line
          x1="6.54813"
          y1="19.786"
          x2="15.5481"
          y2="0.785957"
          stroke="#345948"
        />
      ) : null}
    </svg>
  );
};

Password.defaultProps = {
  type: "open"
};

export default Password;
